import React from 'react';
import { compose } from 'redux';
import withClientId from '@/hocs/with-client-id';
import { withRouter } from 'react-router-dom';
import { Typography, Form, notification, Radio } from '@/elements';

import './index.scss';
import { connect } from 'react-redux';
import * as actions from '@/redux/new_store_structure/actions';
import { DynamicForm } from '@/components';
import { schemas } from './schemas';
import { TESTING_CLIENT_IDS } from '@/config/constants';

const { Title } = Typography;
const RadioGroup = Radio.Group;

class NotificationsForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isEdit: false,
			activeSite: null,
			type: 'core',
			isToAll: this.props.current && this.props.current.targetType === '',
		};
	}

	componentDidMount() {
		const {
			clientId,
			match: {
				params: { id: alertId },
			},
			holders,
			getHoldersList,
			getDetails,
			getSitesList,
		} = this.props;
		getSitesList({ clientId });
		if (alertId !== 'new') {
			this.setState({ isEdit: true });
			getDetails({ clientId, alertId });
		}
		if (holders && holders.length === 0) {
			// get holders list if no holders - else use from redux Store
			getHoldersList({ clientId, with: 'metadata' });
		}
	}
	componentDidUpdate(prevProps, prevState) {
		const { current, clientId } = this.props;
		const { activeSite } = this.state;
		if (
			prevProps.current &&
			this.props.current &&
			prevProps.current.siteId !== this.props.current.siteId
		) {
			this.props.getZonesList({ clientId, siteId: current.siteId });
			this.setState({ activeSite: current.siteId });
		}
		if (activeSite && activeSite !== prevState.activeSite) {
			this.props.getZonesList({ clientId, siteId: activeSite });
		}
		if (this.props.error !== null) {
			this.props.history.push('/notifications/');
		}
		if (
			prevProps.current &&
			this.props.current &&
			prevProps.current.type !== this.props.current.type
		) {
			this.setState({ type: current.type });
		}
	}
	componentWillUnmount() {
		this.props.clearNotificationDetails();
		this.props.clearZonesList();
	}

	onSubmit = values => {
		const {
			current,
			submit,
			history,
			clientId,
			// form: { validateFields },
		} = this.props;
		const { isEdit, type } = this.state;
		const { active, alertId } = current;
		const specificVal = val => (val && val.length > 0 ? val : null);
		submit(
			{
				clientId,
				type,
				active: !!active,
				alertId,
				...values,
				alertTemplate: values.alertTemplate.trim(),
				specificAddress: specificVal(values.specificAddress),
			},
			isEdit ? 'edit' : 'add',
		);
		history.goBack();
	};

	triggerSiteList = val => {
		this.setState({ activeSite: val });
	};
	handleType = e => {
		this.setState({ type: e.target.value });
	};

	render() {
		const {
			current,
			history,
			sitesList,
			zonesList,
			holders,
			clientId,
			verticalConfig,
		} = this.props;
		const { isEdit, type } = this.state;
		const evacDemoEnabled = TESTING_CLIENT_IDS.includes(clientId);
		const enabledVerticals = Object.keys(verticalConfig);
		return (
			<div className="notifications-form">
				<a onClick={() => history.goBack()}>&laquo; Back</a>
				<Title>{isEdit ? 'Edit' : 'Add'} a notification</Title>
				{!isEdit && evacDemoEnabled && (
					<div className={'type-wrap'}>
						<RadioGroup value={type} onChange={this.handleType}>
							<Radio.Button value="core">General</Radio.Button>
							{enabledVerticals.includes('evacuation') && (
								<Radio.Button value="evacuation">
									Evacuation
								</Radio.Button>
							)}
							{enabledVerticals.includes('thermal') && (
								<Radio.Button value="thermal">
									Thermal
								</Radio.Button>
							)}
						</RadioGroup>
					</div>
				)}
				<div className="form-wrap">
					<DynamicForm
						fields={schemas[type](
							current,
							{
								zoneIds: zonesList,
								siteId: sitesList,
								clientReferences: holders,
							},
							{ siteId: this.triggerSiteList },
						)}
						type={type}
						fieldsToReset={[
							'actionType',
							'targetType',
							'frequency',
						]}
						onSubmit={this.onSubmit}
					/>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({
	notifications,
	sites,
	holders,
	user: {
		currentUser: { verticalConfig },
	},
}) => {
	return {
		current: notifications.current,
		loading: notifications.loading,
		error: notifications.errors,
		sitesList: sites.list,
		zonesList: sites.zonesList,
		holders: holders.list,
		verticalConfig,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getDetails: params => dispatch(actions.getNotificationDetails(params)),
		getSitesList: params => dispatch(actions.getSitesList(params)),
		getHoldersList: params => dispatch(actions.getHoldersList(params)),
		getZonesList: params => dispatch(actions.getSitesZonesList(params)),
		clearNotificationDetails: () =>
			dispatch(actions.clearNotificationDetails()),
		clearZonesList: () => dispatch(actions.clearZonesList()),
		submit: (params, effect) =>
			dispatch(actions.addEditNotification(params, effect)),
	};
};

export default compose(
	withRouter,
	withClientId,
	connect(mapStateToProps, mapDispatchToProps),
)(NotificationsForm);



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications-form/index.js